import styled, { css } from 'styled-components';
import { themeColor } from '../../Theming';
import { PropsWithChildren } from 'react';

export const Error = styled.span`
  display: inline-block;
  margin-top: 6px;
  color: ${themeColor('pink')};
`;

export const CommonInputCss = css`
  display: block;
  width: 100%;
  background: none;
  border: none;
  border-bottom: 1px solid ${themeColor('black')};
  height: 35px;
  font-size: 1.125rem;
`;

declare type FormControlElement =
  | HTMLInputElement
  | HTMLSelectElement
  | HTMLTextAreaElement;

export interface FormControlProps extends PropsWithChildren {
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  name?: string;
  value?: string | string[] | number;
  onChange?: React.ChangeEventHandler<FormControlElement>;
  type?: string;
  error?: string;
  touched?: boolean;
}
